'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiVerified = function (_React$Component) {
    _inherits(AiVerified, _React$Component);

    function AiVerified() {
        _classCallCheck(this, AiVerified);

        return _possibleConstructorReturn(this, (AiVerified.__proto__ || Object.getPrototypeOf(AiVerified)).apply(this, arguments));
    }

    _createClass(AiVerified, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M33.186,16.402c-0.671-0.536-1.7-0.536-2.371,0c-1.699,1.357-5.565,3.329-13.685,3.329V37.25 c0,0.215,0.052,0.427,0.155,0.622c0.628,1.187,3.472,5.396,13.934,9.966c0.491,0.214,1.071,0.214,1.562,0 c10.462-4.571,13.307-8.78,13.934-9.966c0.103-0.195,0.155-0.408,0.155-0.622V19.731C38.751,19.731,34.885,17.759,33.186,16.402z M43.876,36.677c0,0.222-0.072,0.439-0.205,0.629c-0.37,0.524-1.073,1.367-2.325,2.425c-2.115,1.787-4.986,3.525-8.547,5.178 c-0.498,0.231-1.099,0.231-1.597,0c-3.562-1.653-6.433-3.392-8.547-5.178c-1.128-0.953-1.81-1.732-2.205-2.26 c-0.213-0.284-0.325-0.616-0.325-0.954v-14.28c6.04-0.375,9.702-1.865,11.876-3.312c2.174,1.447,5.836,2.937,11.876,3.312 L43.876,36.677L43.876,36.677z' }),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M22.77,24.256v12.157c0.859,1.053,3.297,3.472,9.23,6.315c5.932-2.843,8.37-5.262,9.23-6.315V24.256 c-3.139-0.403-6.396-1.187-9.23-2.614C29.167,23.069,25.91,23.853,22.77,24.256z M37.13,27.137l1.02,1.02 c0.352,0.352,0.352,0.923,0,1.275l-6.058,6.058l-1.657,1.657c-0.352,0.352-0.923,0.352-1.275,0l-3.135-3.135 c-0.352-0.352-0.352-0.923,0-1.275l1.02-1.02c0.352-0.352,0.923-0.352,1.275,0l1.478,1.478l6.058-6.058 C36.207,26.785,36.778,26.785,37.13,27.137z' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-verified', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-verified', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiVerified;
}(_react2.default.Component);

exports.default = AiVerified;